<template>
  <div class="modal fade" id="add-call" tabindex="-1" role="dialog" aria-labelledby="modal-large" aria-hidden="true">
    <div class="modal-dialog modal-dialog-popin modal-lg" role="document">
        <div class="modal-content">
          <form @submit.prevent="storeCallPhone()">
            <div class="block block-themed block-transparent mb-0 block-mode-loading-refresh" :class="{'block-mode-loading': isProcessing}">
                <div class="block-header bg-gd-dusk">
                    <h3 class="block-title">{{ $t('calls.add') }}</h3>
                    <div class="block-options">
                        <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
                <div class="block-content">
                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <label class="col-form-label">{{ $t('phones.owner') }}</label>
                        <p v-if="phone.debtor.fullname" >{{phone.debtor.fullname}}</p>
                        <p v-if="phone.contact_face.fullname" >{{phone.contact_face.fullname}}</p>
                      </div>
                      <div class="form-group">
                        <label class="col-form-label">{{ $t('phones.phone') }}</label>
                        <input type="text" class="form-control" v-mask="'#(###)###-####'" v-model="phone.phone" readonly disabled>
                      </div>
                      <div class="form-group">
                        <div class="row">
                          <label class="col-sm-5 col-form-label pt-0">{{ $t('calls.type.name') }} </label>
                          <div class="col-sm-7">
                            <div class="custom-control custom-radio" v-for="type in listCallTypes" :key="type.id">
                              <input type="radio" :id="type.slug" v-model="call.type_id" :value="type.id" class="custom-control-input">
                              <label class="custom-control-label" :for="type.slug">{{type.name}}</label>
                            </div>

                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-form-label">{{ $t('calls.call_status_name') }}</label>
                        <select v-model="call.status_id" class="form-control" :class="{'is-invalid': errors.status_id }">
                          <option selected="true" disabled value="">{{ $t('placeholder.select_status') }}</option>
                          <option v-for="status in listCallStatuses" :value="status.id" :key="status.id">
                            {{ status.name }}
                          </option>
                        </select>
                        <span v-if="errors.status_id" class="invalid-feedback">
                            <strong>{{ errors.status_id ? errors.status_id[0] : '' }}</strong>
                        </span>
                      </div>
                      <div class="form-group">
                        <label  class="col-form-label">{{ $t('debts.next_contact_short') }}</label>
                        <input type="date" class="form-control" v-model="call.next_contact" :class="{'is-invalid': errors.next_contact }">
                        <span v-if="errors.next_contact" class="invalid-feedback">
                            <strong>{{ errors.next_contact ? errors.next_contact[0] : '' }}</strong>
                        </span>
                      </div>
                      <div class="form-group">
                        <label class="col-form-label">{{ $t('app.comment') }}</label>
                        <textarea class="form-control" name="name" rows="3" cols="80" v-model="call.comment" :class="{'is-invalid': errors.comment }"></textarea>
                        <span v-if="errors.comment" class="invalid-feedback">
                            <strong>{{ errors.comment ? errors.comment[0] : '' }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col">
                      <h5>{{ $t('options.extra_short') }}</h5>
                      <div class="form-group" >
                        <label class="col-form-label">{{ $t('debtors.status') }}</label>
                        <select class="form-control" v-model="call.debt_status_id" :class="{'is-invalid': errors.debt_status_id }">
                          <option selected="true" disabled value="">{{ $t('placeholder.select') }}</option>
                          <option v-for="status in listDebtStatuses" :value="status.id" :key="status.id">
                            {{ status.name }}
                          </option>
                        </select>
                        <span v-if="errors.debt_status_id" class="invalid-feedback">
                            <strong>{{ errors.debt_status_id ? errors.debt_status_id[0] : '' }}</strong>
                        </span>
                      </div>
                      <div class="form-group" v-if="promised_statuses.indexOf(call.debt_status_id) != -1">
                        <label  class="col-form-label">{{ $t('calls.promised_amount') }}</label>
                        <input type="text" class="form-control" v-model="call.promised_amount" :class="{'is-invalid': errors.promised_amount }">
                        <span v-if="errors.promised_amount" class="invalid-feedback">
                            <strong>{{ errors.promised_amount ? errors.promised_amount[0] : '' }}</strong>
                        </span>
                      </div>
                      <div class="form-group" v-if="promised_statuses.indexOf(call.debt_status_id) != -1">
                        <label  class="col-form-label">{{ $t('calls.promised_date') }}</label>
                        <input type="date" class="form-control" v-model="call.promised_date" :class="{'is-invalid': errors.promised_date }">
                        <span v-if="errors.promised_date" class="invalid-feedback">
                            <strong>{{ errors.promised_date ? errors.promised_date[0] : '' }}</strong>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-alt-secondary" data-dismiss="modal" :disabled="isProcessing">
                  {{ $t('buttons.cancel') }}
                </button>
                <button type="submit" class="btn btn-alt-success" :disabled="isProcessing">
                    <i class="fa" :class="{'fa-check': !isProcessing, 'fa-spinner fa-pulse fa-fw': isProcessing }"></i> {{ $t('buttons.ok') }}
                </button>
            </div>
          </form>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: [
    'debtId',
    'debtorIin',
  ],
  data() {
    return {
      promised_statuses: [2, 4, 5],
      call: {
        debt_id: '',
        phone_id: '',
        status_id: '',
        type_id: '1',
        next_contact: '',
        promised_date: '',
        promised_amount: '',
        comment: '',
        reason_id: '',
        debt_status_id: '',
      },
      errors: {},
      isProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      'debt',
      'listDebtStatuses',
      'listCallStatuses',
      'listCallTypes',
      'phone',
    ]),
  },
  mounted() {
    this.GET_LIST_DEBT_STATUSES();
    this.GET_LIST_CALL_STATUSES();
    this.GET_LIST_CALL_TYPES();
  },
  methods: {
    ...mapActions([
      'GET_LIST_CALL_STATUSES',
      'GET_LIST_CALL_TYPES',
      'GET_LIST_DEBT_STATUSES',
      'STORE_CALL_PHONE',
      'GET_PHONES',
      'GET_CALLS',
    ]),
    clearCallModal() {
      this.call = {
        status_id: '',
        type_id: '1',
        next_contact: '',
        comment: '',
        reason_id: '',
        debt_status_id: '',
        promised_amount: '',
        promised_date: '',
      };
      this.errors = {};
    },
    storeCallPhone() {
      this.isProcessing = true;
      if (this.phone.debtor.fullname) {
        this.call.is_debtor = true;
      } else {
        this.call.is_debtor = false;
      }
      this.call.phone_id = this.phone.id;
      this.call.debt_id = this.debt.id;
      this.STORE_CALL_PHONE(this.call)
        .then(() => {
          $('#add-call').modal('hide');
          this.clearCallModal();
          this.GET_CALLS(this.$route.params.id);
          if (this.debt.debtor_iin) {
            this.GET_PHONES(this.debt.debtor_iin);
          }
        })
        .catch((err) => {
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
